import { render, staticRenderFns } from "./Question.template.vue?vue&type=template&id=3639fe7a&"
import script from "./Question.template.vue?vue&type=script&lang=js&"
export * from "./Question.template.vue?vue&type=script&lang=js&"
import style0 from "./Question.template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports